// Brands whose accounts have not moved to the new reporting suite, so the retirement notice would be untrue.
const BRANDS_WITHOUT_BANNER = ['censornet', 'coro'];

export const shouldShowReportingBanner = ({ isAdmin, dismissed, brandType }) =>
    Boolean(isAdmin) && !dismissed && !BRANDS_WITHOUT_BANNER.includes(brandType);
